import * as Yup from 'yup';

export const validateModel = Yup.object().shape({
  
});